export enum PrintSettings {
    Invoice_ShowItemNumber = "Invoice_ShowItemNumber",
    Invoice_ShowDispatchComments = "Invoice_ShowDispatchComments",
    Invoice_ShowIssueFound = "Invoice_ShowIssueFound",
    Invoice_ShowInvoiceComments = "Invoice_ShowInvoiceComments",
    Invoice_ShowAgreementSavings = "Invoice_ShowAgreementSavings",

    WorkOrder_ShowDispatchCommments = "WorkOrder_ShowDispatchCommments",
    WorkOrder_ShowIssueFound = "WorkOrder_ShowIssueFound",    
    WorkOrder_ShowItemNumber = "WorkOrder_ShowItemNumber",
    WorkOrder_ShowAgreementSavings = "WorkOrder_ShowAgreementSavings",
    Estimate_ShowCustomerSignature = "Estimate_ShowCustomerSignature",
    Estimate_ShowItemNumber = "Estimate_ShowItemNumber",
    Estimate_ShowAgreementSavings = "Estimate_ShowAgreementSavings"
}